import CylinderAccessInfo from './cylinder_access_info';

export default CylinderAccessInfo;
